import { ElementType, HTMLAttributes } from 'react'
import { cn } from '../../lib/cn.js'
import styles from './Stack.module.css'

export interface StackProps extends HTMLAttributes<HTMLElement> {
  direction?: 'row' | 'column'
  gap?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 8 | 10 | 12
  align?: 'start' | 'center' | 'end' | 'stretch' | 'baseline'
  justify?: 'start' | 'center' | 'end' | 'between' | 'around'
  wrap?: boolean
  as?: ElementType
}

export function Stack({
  direction = 'column',
  gap = 4,
  align,
  justify,
  wrap,
  as: Tag = 'div',
  className,
  style,
  ...props
}: StackProps) {
  return (
    <Tag
      className={cn(styles.root, className)}
      style={{
        flexDirection: direction,
        gap: `var(--ds-space-${gap})`,
        alignItems: align === 'start' ? 'flex-start'
          : align === 'end' ? 'flex-end'
          : align,
        justifyContent: justify === 'start' ? 'flex-start'
          : justify === 'end' ? 'flex-end'
          : justify === 'between' ? 'space-between'
          : justify === 'around' ? 'space-around'
          : justify,
        flexWrap: wrap ? 'wrap' : undefined,
        ...style,
      }}
      {...props}
    />
  )
}
